import { handleActions } from 'redux-actions';
import moment from 'moment';
import csv from 'csv-stringify';
import endpoints from '../../../config/endpoints';
import {list as externalOfferDomains} from '../../../../shared/js/externalOfferDomains';

import http from '../../shared/http';
import intl from '../../shared/intl';
import checkIsExcludedCountryCode from '../../shared/checkIsExcludedCountryCode';
import defaultGeoCurrency from '../../../../shared/js/geo-currency_relations';
import { SubmissionError, formValueSelector, change, getFormValues } from 'redux-form';
import { LOCATION_CHANGE, replace } from 'react-router-redux';
import { baseUrl } from '../../../config/route-entry-point';
import { formatEnumFormOptions } from '../../shared/format';
import createCalendar from '../../shared/calendar';
import createFilters from '../../shared/filters';
import randExp from 'randexp';
import { create as paginationCreate } from '../../shared/pagination';
import { calculateGeoGoals, getLangsByTargetRelation } from '../../offers/shared';
import geoLangs from '../../../../shared/js/geo_landing_lang_relations';

import { REFETCH_ALL_DATA, actions as rootActions } from '../../root';

import concat from 'lodash/concat';
import cloneDeep from 'lodash/cloneDeep';
import find from 'lodash/find';
import isObject from 'lodash/isObject';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import difference from 'lodash/difference';
import intersectionBy from 'lodash/intersectionBy';
import map from 'lodash/map';
import filter from 'lodash/filter';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import forEach from 'lodash/forEach';
import without from 'lodash/without';
import every from 'lodash/every';
import pick from 'lodash/pick';
import get from 'lodash/get';

import qs from 'qs';

import {
	getPagesByType,
	getSnippetsByType,
	getPagesFromItemField,
	getLandingSnippetsFields,
	checkIsFromChain
} from '../functions';

import { enum as domainTypes } from '../../../../../enums/campaign-domain-types';
import { enum as offerDomainTypes } from '../../../../../enums/offer-domain-types';
import { enum as postbackLogTypes } from '../../../../../enums/postback-log-types';
import { enum as postbackTypes } from '../../../../../enums/postback-types';
import { enum as advSystems } from '../../../../../enums/adv-systems';
import { enum as offerStatuses } from '../../../../../enums/offer-statuses';

export const displayType = {
	list: 'list',
	tile: 'tile'
};

const pagination = paginationCreate('stream', {
	LandingsTable: {
		currentPage: 1,
		perPage: 1000
	},
	TransitionsTable: {
		currentPage: 1,
		perPage: 10
	}
});

const calendarPostbackList = createCalendar({
	namespace: 'stream',
	stateNodeName: 'calendarPostbackList',
	defaultValue: {
		start: moment().subtract(14, 'days').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
		end: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
	}
});

const postbackFilters = createFilters({
	namespace: 'stream',
	stateNodeName: 'filters',
	filtersInitialState: [{
		title: 'SubID',
		suggest: [
			{
				placeholder: 'SID1',
				key: 'sid1',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID1,
					type: 'fromServer'
				}
			},
			{
				placeholder: 'SID2',
				key: 'sid2',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID2,
					type: 'fromServer'
				}
			},
			{
				placeholder: 'SID3',
				key: 'sid3',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID3,
					type: 'fromServer'
				}
			},
			{
				placeholder: 'SID4',
				key: 'sid4',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID4,
					type: 'fromServer'
				}
			},
			{
				placeholder: 'SID5',
				key: 'sid5',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID5,
					type: 'fromServer'
				}
			}
		]
	}]
});

const manualTouchedFields = [];
// actions types
const FETCH_DATA_SUCCESS = 'stream/fetch-data-success';
const FETCH_DATA_ERROR = 'stream/fetch-data-error';
const FETCH_DOMAINS_SUCCESS = 'stream/fetch-domains-success';
const FETCH_DOMAINS_ERROR = 'stream/fetch-domains-error';

const FETCH_GEO_LANG_SUCCESS = 'stream/fetch-geo-lang-success';
const FETCH_GEO_LANG_ERROR = 'stream/fetch-geo-lang-error';

const FETCH_OFFER_FOR_STREAM_SUCCESS = 'stream/fetch-offer-for-stream-success';
const FETCH_OFFER_FOR_STREAM_ERROR = 'stream/fetch-offer-for-stream-error';
const FETCH_STATS_FOR_OFFER_SUCCESS = 'stream/fetch-stats-for-offer-success';
const FETCH_STATS_FOR_OFFER_ERROR = 'stream/fetch-stats-for-offer-error';

const FETCH_OFFERS_OPTIONS_SUCCESS = 'stream/fetch-offer-options-success';

const SAVE_DATA_SUCCESS = 'stream/save-data-success';
const SAVE_DATA_ERROR = 'stream/save-data-error';

const TOGGLE_PROGRESS_BAR = 'stream/toggle-progress-bar';

const SAVE_LOADER_ON = 'stream/save-loader-on';
const SAVE_LOADER_OFF = 'stream/save-loader-off';

const SHOW_MORE_POSTBACKS_SUCCESS = 'stream/show-more-postbacks-success';
const SHOW_MORE_POSTBACKS_ERROR = 'stream/show-more-postbacks-error';

const FETCH_POSTBACKS_SUCCESS = 'stream/fetch-postbacks-success';
const FETCH_DOWNLOAD_POSTBACKS_SUCCESS = 'stream/fetch-download-postbacks-success';

const MORE_POSTBACKS_HIDE = 'stream/more-postbacks-hide';
const MORE_POSTBACKS_SHOW = 'stream/more-postbacks-show';

const CHANGE_SECTION = 'stream/change-section';
const SORT_BY_COLUMN = 'stream/sort-by-column';
const TOGGLE_GEO_STATS = 'stream/show-all-geo-stats';

const CHANGE_DISPLAY_TYPE = 'stream/change-display-type';
const CHANGE_ADV_SYSTEM = 'stream/change-adv-system';
const CHANGE_CURRENCY = 'stream/change-currency';

const BOOST_SUCCESS = 'stream/boost-success';
const BOOST_ERROR = 'stream/boost-error';

const UPDATE_POPUPS_AVAILABILITY = 'stream/update-popups-availability';
const TOGGLE_RULES_POPUP = 'stream/toggle-rules-popup';

const SET_POSTBACK_SEARCH = 'stream/set-postback-search';

const CLONE_ITEM_SUCCESS = 'streams/clone-data-success';
const CLONE_ITEM_ERROR = 'streams/clone-data-error';

const isRocket = process.env.CPA_ENV === 'rocket';
const volatiles = {
	defaultInitialRedirectDomain: isRocket ? externalOfferDomains[0] : '',
	getDefaultRedirectDomain: (domains) => isRocket ? externalOfferDomains[0] : domains[0]
};

const DOWNLOAD_LIMIT = 10000;

// initial state
const initialState = {
	data: null,
	isRulesPopupVisible: false,
	isSaveButtonLoader: false,
	sections: {
		list: {
			main: 'main',
			postback: 'postback',
			postbacklog: 'postbacklog',
			additional: 'additional'
		},
		active: 'main'
	},
	fields: {
		adv_system: null,
		currency: null,
		language: null,
		external_landing_domain: '',
		external_transit_domain: '',
		customer_popups_enabled: false,
		mouseout_popup_enabled: false,
		phone_button_popup_enabled: false,
		additional_phone_enabled: false,
		landing_domain_type : domainTypes.internal,
		landing_pages: null,
		transit_domain_type: domainTypes.internal,
		transit_pages: null,
		internal_landing_domain: '',
		internal_landing_subdomain: '',
		internal_transit_domain: '',
		internal_transit_subdomain: '',
		redirect_domain_type: domainTypes.internal,
		internal_redirect_subdomain: '',
		internal_redirect_domain: volatiles.defaultInitialRedirectDomain,
		external_redirect_domain: '',
		postback_ignore_trash: false,
		postback_only_approved: false,
		postback_send_status: false,
		postback_ignore_restricted: false,
		postback_on_payout_change: false,
		postback_only_rejected: false,
		postback_only_trash: false,
		postback_url: null,
		sid1_utm: 'utm_content',
		sid2_utm: 'utm_medium',
		sid3_utm: 'utm_source',
		sid4_utm: 'utm_campaign',
		sid5_utm: '',
		space: null,
		title: '',
		trafficback_url: null,
		user_offer: null
	},
	excludeFieldsForNotAdvSystem: [
		'external_landing_domain',
		'external_transit_domain',
		'landing_domain_type',
		'transit_domain_type',
		'internal_landing_subdomain',
		'internal_transit_subdomain',
		'trafficback_url',
		'show-utm-settings',
		'customer_popups_enabled',
		'mouseout_popup_enabled',
		'phone_button_popup_enabled',
		'additional_phone_enabled'
	],
	excludeFieldsForMyTargetSystem: [
		'external_transit_domain',
		'transit_domain_type',
		'internal_transit_subdomain',
		'trafficback_url',
		'show-utm-settings',
		'customer_popups_enabled',
		'mouseout_popup_enabled',
		'additional_phone_enabled',
		'phone_button_popup_enabled'
	],

	// list or tile
	landingsDisplayType: displayType.tile,
	transitionsDisplayType: displayType.tile,

	pagination: pagination.initState,
	columnSorting: {
		landing: {
			key: null,
			direction: 'desc',
			position: 'display_priority'
		},
		transit: {
			key: null,
			direction: 'desc',
			position: 'display_priority'
		}
	},
	landingTransitColumns: {
		tile: isRocket ? {} : {
			title: {
				id: 'title',
				direction: 'desc',
				position: 'title',
				title: 'Название',
				className: ''
			},
			cr: {
				id: 'cr',
				direction: 'desc',
				position: 'cr',
				title: 'crl',
				className: 'data-value'
			}
		},
		list: {
			title: {
				id: 'title',
				direction: 'desc',
				position: 'title',
				title: 'Название',
				className: ''
			},
			domain: {
				id: 'domain',
				direction: 'desc',
				position: 'domain',
				title: 'link',
				className: ''
			},
			cr: {
				id: 'cr',
				direction: 'desc',
				position: 'cr',
				title: 'crl',
				className: 'data-value'
			}
		}
	},

	geoStats: null,
	selectedOffer: null,
	selectedCurrency: null,
	showProgressBar: false,
	validate: {},
	popupsAvailability: {
		customer_popups_available: false,
		mouseout_popup_available: false,
		phone_button_popup_available: false,
		additional_phone_available: false
	},
	selectedLandingsIds: [],
	query: {},
	filters: postbackFilters.initialState,
	calendarPostbackList: calendarPostbackList.initialState,
	postbackSearch: '',
	error: null
};

const paginatedItemsCount = 8;
const initialLimit = 8;

const headersConfig = [{
	id: 'date',
	title: 'date'
}, {
	id: 'url',
	title: 'url'
}, {
	id: 'status',
	title: 'status'
}];

const postbackTypeToCheckboxMapping = {
	postback_only_approved: postbackTypes.approve,
	postback_send_status: postbackTypes.status,
	postback_only_pending: postbackTypes.pending,
	postback_only_rejected: postbackTypes.rejected,
	postback_only_trash: postbackTypes.trash
};

// actions
export const actions = {
	fetchOffer: offerId => (dispatch, getState) => {
		const state = getState();
		const {traffic_source, id} = getFormValues('streamForm')(getState());

		const isEditMode = selectors.isEditMode(state);

		if (offerId) {
			const request = http({
				url: `${endpoints.OFFERS.LIST}/${offerId}?campaign_id=${id || ''}`,
				method:'get',
				actions: [
					FETCH_OFFER_FOR_STREAM_SUCCESS,
					FETCH_OFFER_FOR_STREAM_ERROR
				],
				addToResponse: {
					traffic_source: traffic_source && traffic_source.value
				}
			});
			request(dispatch).then(action => {
				const state = getState();
				const chain = get(state, ['routing', 'locationBeforeTransitions', 'state', 'chain'], {});
				let language = null;
				const  externalIntegration = get(action, 'payload.data.external_integration');

				if (!isEmpty(chain)) {
					const { id, text } = find(getState().app.lists['landing-languages'], {id: chain.language});
					language = { value: id, label: text };

					dispatch(change('streamForm', `landing_pages_id_${chain.landing_id}`, true));
					dispatch(change('streamForm', `transit_pages_id_${chain.transit_id}`, true));
				}
				if (['smartcredit_conversion', 'smartcredit_lead'].includes(externalIntegration)) {
					const { id, text } = find(getState().app.lists['landing-languages'], {id: 'ru'});
					language = { value: id, label: text };
					dispatch(change('streamForm', 'space', null));
				}
				dispatch(actions.fetchOfferStats(offerId));
				if (!isEditMode) {
					if (language == null) {
						dispatch(change('streamForm', 'country_code', null));
					}
					dispatch(change('streamForm', 'language', language));
				}
				dispatch(actions.checkLandingsPopups());
			});
		}
	},
	showMore: () => (dispatch, getState) => {
		const itemsInListCount = get(getState(), 'stream.data.postbacklog.length');
		const streamId = get(getState(), 'stream.data.streamItemData.id');
		const filters = getPostbackFilters(getState());
		const search = selectors.getPostbackSearch(getState());
		http({
			url: `${endpoints.STREAM.POSTBACK_LOGS.replace('{streamId}', streamId)}
				/${postbackLogTypes.campaign}
				?${qs.stringify({
		limit: paginatedItemsCount,
		filters,
		search,
		offset: itemsInListCount
	})}`,
			method: 'get',
			actions: [SHOW_MORE_POSTBACKS_SUCCESS, SHOW_MORE_POSTBACKS_ERROR]
		})(dispatch).then(response => {
			if (get(response, 'payload.data.length') < paginatedItemsCount)
				dispatch(actions.hideMorePostbacks());
		});
	},
	hideMorePostbacks: () => ({
		type: MORE_POSTBACKS_HIDE
	}),
	downloadPostbacks: (e) => (dispatch, getState) => {
		e.preventDefault();
		const filters = getPostbackFilters(getState());
		const search = selectors.getPostbackSearch(getState());

		const streamId = get(getState(), 'stream.data.streamItemData.id', null);
		const url = `${endpoints.STREAM.POSTBACK_LOGS.replace('{streamId}', streamId)}/
			${postbackLogTypes.campaign}?${qs.stringify({ limit: DOWNLOAD_LIMIT, offset: 0, search, filters })}`;

		return http({
			url,
			method:'get',
			actions: [ FETCH_DOWNLOAD_POSTBACKS_SUCCESS ]
		})(dispatch)
			.then(action => {
				if (action.type === FETCH_DOWNLOAD_POSTBACKS_SUCCESS) {
					const rows = [].concat(
						[headersConfig.map(hc => hc.title)],
						action.payload.data.map(pl => Object.values(pick(pl, ['date', 'url', 'status'])))
					);
					createCsvFromArray(rows);
				}
			});
	},
	fetchOfferStats: offerId => (dispatch, getState) => {
		const state = getState();
		const formData = getFormValues('streamForm')(state);
		const offer_id = offerId || state.stream.selectedOffer && state.stream.selectedOffer.id;
		const bestCurrency = determineBestCurrency(state.stream.data.streamItemData,
			state.stream.selectedOffer,
			state
		);
		const currencyObj = state.stream.selectedCurrency && state.stream.selectedCurrency
			|| formData && formData.currency
			|| bestCurrency;

		if (offer_id && currencyObj && currencyObj.value) {
			const request = http({
				url: `${endpoints.OFFERS.LIST}/${offer_id}/geo-stats?currency=${currencyObj.value}`,
				method:'get',
				actions: [
					FETCH_STATS_FOR_OFFER_SUCCESS,
					FETCH_STATS_FOR_OFFER_ERROR
				],
				addToResponse: currencyObj
			});
			request(dispatch);
		}

	},
	toggleRulesPopup: () => ({
		type: TOGGLE_RULES_POPUP
	}),

	fetchData: (params) => (dispatch, getState) => {
		const { streamId, offerId } = params.params;

		const url = [
			endpoints.LISTS.ADV_SYSTEMS,
			endpoints.LISTS.LANDING_SNIPPETS,
			`${endpoints.LISTS.CAMPAIGN_DOMAINS}?adv_system=other`,
			endpoints.SPACES.LIST,
			`${endpoints.LOOKUPS.OFFERS}?only_available=true&limit=0`
		];

		if (streamId) {
			url.push(endpoints.STREAM.ROOT + '/' + streamId);
			url.push(endpoints.PROFILE.GLOBAL_POSTBACK);
			url.push(`
				${endpoints.STREAM.POSTBACK_LOGS.replace('{streamId}', streamId)}
				/${postbackLogTypes.campaign}
				?${qs.stringify({ limit: initialLimit, offset: 0 })}
			`);
		}

		let request = http({
			url,
			method:'get',
			actions: [
				FETCH_DATA_SUCCESS,
				FETCH_DATA_ERROR
			]
		});

		dispatch({ type: TOGGLE_PROGRESS_BAR });

		return request(dispatch).then(action => {
			dispatch({ type: TOGGLE_PROGRESS_BAR });

			if (streamId) {
				const adv = action.payload[5].data.adv_system;
				if (adv != advSystems.other) {
					dispatch(actions.fetchDomains(action.payload[5].data.adv_system));
				}
			}
			if (offerId || streamId) {
				const offer_id = offerId || getState().stream.data.streamItemData.offer_id;
				dispatch(actions.fetchOffer(offer_id));
			}
		});
	},
	fetchPostbacks: (e) => (dispatch, getState) => {
		e.preventDefault();
		const filters = getPostbackFilters(getState());
		const search = selectors.getPostbackSearch(getState());

		const streamId = get(getState(), 'stream.data.streamItemData.id', null);
		const url = `${endpoints.STREAM.POSTBACK_LOGS.replace('{streamId}', streamId)}/
			${postbackLogTypes.campaign}?${qs.stringify({ limit: initialLimit, offset: 0, search, filters })}`;

		const request = http({
			url,
			method:'get',
			actions: [ FETCH_POSTBACKS_SUCCESS ]
		});

		return request(dispatch).then(response => {
			dispatch({
				type: get(response, 'payload.data.length') >= paginatedItemsCount
					? MORE_POSTBACKS_SHOW
					: MORE_POSTBACKS_HIDE
			});
		});
	},

	fetchDomains: (adv) => (dispatch, getState) => {
		const state = getState();
		const formData = getFormValues('streamForm')(state);
		const url = `${endpoints.LISTS.CAMPAIGN_DOMAINS}?adv_system=${adv}`;

		const request = http({
			url,
			method:'get',
			actions: [
				FETCH_DOMAINS_SUCCESS,
				FETCH_DOMAINS_ERROR
			]
		});

		request(dispatch).then(action => {
			const campaignDomains = action.payload && action.payload.data.map(d => ({
				label: d.text,
				value: d.id
			}));

			if (!isEmpty(campaignDomains) && formData
			&& formData.internal_landing_domain == null
			) {
				dispatch(change('streamForm', 'internal_landing_domain', campaignDomains[0]));
				dispatch(change('streamForm', 'internal_transit_domain', campaignDomains[0]));
			}
		});
	},
	fetchLangugeRules: language => (dispatch, getState) => {
		const userLang = get(getState(), 'app.userData.general.language', 'en');
		const url = `${endpoints.LANG_RULES.SINGLE.replace('{lang}', language)}?dashboard_lang=${userLang}`;

		const request = http({
			url,
			method:'get',
			actions: [
				FETCH_GEO_LANG_SUCCESS,
				FETCH_GEO_LANG_ERROR
			]
		});
		return request(dispatch);
	},
	saveManualTouch: fieldName => (dispatch, getState) => {
		return !manualTouchedFields.includes(fieldName) && manualTouchedFields.push(fieldName);
	},
	setDefaultLanguage: geo => (dispatch, getState) => {
		if (!manualTouchedFields.includes('currency')) {
			const defCurrency = 'usd';
			actions.changeCurrency({ label: defCurrency, value: defCurrency })(dispatch);
		}
		if (!manualTouchedFields.includes('language')) {
			const state = getState();
			const availableLangs = selectors.getSelectOptions(state).languages;
			const languageDueToGeo = geoLangs[geo];
			if (languageDueToGeo && languageDueToGeo.length) {
				const selectorValue = availableLangs.find(lang => lang.value == languageDueToGeo[0] );
				if (selectorValue) {
					dispatch(change('streamForm', 'language', selectorValue));
					actions.fetchLangugeRules(selectorValue && selectorValue.value)(dispatch, getState);
				}
			}
		}
	},
	resetCurrency: () => dispatch => {
		dispatch(change('streamForm', 'currency', null));
	},
	setDefaultCountryCode: language => (dispatch, getState) => {
		const state = getState();
		if (manualTouchedFields.includes('country_code')) {
			return;
		}
		const availableGeos = selectors.getSelectOptions(state).geos;
		function handleRuLang() {
			const selectorValue = availableGeos.find(geo => geo.value == 'RU');
			if (selectorValue) {
				const defCurrency = defaultGeoCurrency[selectorValue.value] || 'usd';
				actions.changeCurrency({ label: defCurrency, value: defCurrency })(dispatch);
				dispatch(change('streamForm', 'country_code', selectorValue));

			}
		}
		switch (language) {
			case 'ru': handleRuLang();
		}
		function searchGeo (index) {
			const maxIndex = 5;
			const selectorValue = availableGeos.find(geo => geoLangs[geo.value] && geoLangs[geo.value][index] == language);
			if (!selectorValue && index < maxIndex) {
				return searchGeo(++index);
			}
			return selectorValue;
		}
		const selectorValue = searchGeo(0);
		if (selectorValue) {
			const defCurrency = defaultGeoCurrency[selectorValue.value] || 'usd';
			actions.changeCurrency({ label: defCurrency, value: defCurrency })(dispatch);
			dispatch(change('streamForm', 'country_code', selectorValue));
		}
	},

	saveForm: data => (dispatch, getState) => {
		const isEdit = !!getState().stream.data.streamItemData;
		const method = isEdit ? 'put' : 'post';
		const url = isEdit
			? `${endpoints.STREAM.ROOT}/${getState().stream.data.streamItemData.id}`
			: endpoints.STREAM.ROOT;
		dispatch(actions.validateStreamForm(data));

		const reqData = createRequest(data, getState());

		const request = http({
			url,
			method,
			actions: [
				SAVE_DATA_SUCCESS,
				SAVE_DATA_ERROR
			],
			data: reqData
		});
		dispatch(actions.turnOnSaveButtonLoader());
		return request(dispatch).then(action => {
			dispatch(actions.turnOffSaveButtonLoader());
			if (action.type === SAVE_DATA_SUCCESS) {
				if (window.dataLayer && !isEdit) {
					window.dataLayer.push({'event': 'FormSubmission', 'eventCategory': 'Stream', 'eventAction': 'GetStream'});
				}
				dispatch(replace(baseUrl('campaigns/')));
			}

			if (action.type === SAVE_DATA_ERROR && action.payload.response.status === 400) {
				const validationsErrors = {};
				const responseErrors = action.payload.response.data;

				forEach(responseErrors, value => {
					const key = value.dataPath.slice(1);
					validationsErrors[key] = value.message;
					if (key === 'landing_domain') {
						if (data.landing_domain_type === domainTypes.internal) {
							validationsErrors.internal_landing_subdomain = value.message;
						} else {
							if (!validationsErrors.external_landing_domain) {
								validationsErrors.external_landing_domain = value.message;
							}
						}
					}
					if (key === 'transit_domain') {
						if (data.landing_domain_type === domainTypes.internal)
						{
							validationsErrors.internal_transit_subdomain = value.message;
						} else {
							if (!validationsErrors.external_transit_domain) {
								validationsErrors.external_transit_domain = value.message;
							}
						}
					}
					if (key === 'redirect_domain') {
						if (data.redirect_domain_type === domainTypes.internal)
						{
							validationsErrors.internal_redirect_subdomain = value.message;
						} else {
							if (!validationsErrors.external_redirect_domain) {
								validationsErrors.external_redirect_domain = value.message;
							}
						}
					}
				});

				if (!isEmpty(validationsErrors)) {
					const errorKey = Object.keys(validationsErrors)[0];
					dispatch(actions.changeSection(validationsErrors.postback_url ? 'postback' : 'main'));
					dispatch(actions.scrollToId(errorKey));
				}

				throw new SubmissionError(validationsErrors);
			}
		});
	},

	changeSection: sectionName => ({
		type: CHANGE_SECTION,
		payload: sectionName
	}),

	pagination: () => dispatch => pagination.actions(dispatch),
	turnOnSaveButtonLoader: () => ({type: SAVE_LOADER_ON }),
	turnOffSaveButtonLoader: () => ({type: SAVE_LOADER_OFF }),

	sortByColumn: (type, columnKey, section) => ({
		type: SORT_BY_COLUMN,
		payload: { type, columnKey, section }
	}),

	toggleGeoStats: () => ({type: TOGGLE_GEO_STATS}),

	changeDisplayType: type => ({
		type: CHANGE_DISPLAY_TYPE,
		payload: type
	}),

	validateStreamForm: (values) => (dispatch, getState) => {
		const intl = selectors.getIntl(getState());
		const isEditMode = selectors.isEditMode(getState());

		const errors = {};

		if (!values.external_landing_domain && values.landing_domain_type === 'external') {
			errors.external_landing_domain = intl('Введите домен');
		}
		if (!values.traffic_source && !isEditMode) {
			errors.traffic_source = intl('Введите источник трафика');
		}
		if (!values.external_transit_domain && values.transit_domain_type === 'external') {
			errors.external_transit_domain = intl('Введите домен');
		}
		if (!isEmpty(errors)) {
			const errorKey = Object.keys(errors)[0];
			dispatch(actions.changeSection('main'));
			setTimeout(() => dispatch(actions.scrollToId(errorKey)), 300);
			throw new SubmissionError(errors);
		}
	},

	changeAdvSystem: space => (dispatch, getState) => {
		const streamFormSelector = formValueSelector('streamForm');
		const {
			title, user_offer, currency, landing_pages
		} = streamFormSelector(getState(), 'title', 'user_offer', 'currency', 'landing_pages');

		const adv_system = space && space.value == -1 ? advSystems.target_mail : advSystems.other;

		dispatch(change('streamForm', 'internal_landing_domain', null));
		dispatch(actions.fetchDomains(adv_system));

		return dispatch({
			type: CHANGE_ADV_SYSTEM,
			payload: {
				adv_system, title, user_offer, currency,
				landing_pages: adv_system !== advSystems.other ? landing_pages : null
			}
		});
	},

	changeCurrency: currency => dispatch => {
		dispatch({type: CHANGE_CURRENCY, payload: currency});
		dispatch(change('streamForm', 'currency', currency));
		dispatch(actions.fetchOfferStats());
	},

	scrollToId: htmlID => (dispatch, getState) => {
		const scrollTop = window.pageYOffset;
		const element = document.getElementById(htmlID);
		if (!element) {return;}
		window.scrollTo(0, element.getBoundingClientRect().top + scrollTop - 20);//20 add more pixels to scroll
	},

	checked: (checkboxName) => (dispatch, getState) => {
		dispatch(change('streamForm', 'postback_ignore_trash', false));
	},

	getOffersOptions: text => (dispatch, getState) => {
		const options = {
			only_available: true,
			limit: 100,
			query: text || ''
		};

		const request = http({
			url: `${endpoints.LOOKUPS.OFFERS}?${qs.stringify(options)}`,
			method: 'get',
			actions: [FETCH_OFFERS_OPTIONS_SUCCESS, FETCH_DATA_ERROR]
		});

		return request(dispatch).then(action => {
			if (action.type === FETCH_OFFERS_OPTIONS_SUCCESS) {
				let options = action.payload.data.map(item => ({ value: item.id, label: item.text }));
				return { options };
			}
		});
	},
	boost: (clickedLocation) => (dispatch, getState) => {
		const {id: offerId} = getState().stream.selectedOffer;
		const request = http({
			url: `${endpoints.OFFERS.LIST}/${offerId}/boost`,
			method: 'put',
			data: {clickedLocation},
			addToResponse: {
				offerId, clickedLocation
			},
			actions: [BOOST_SUCCESS, BOOST_ERROR]
		});

		dispatch(rootActions.spinnerToggle());
		request(dispatch).then(() => dispatch(rootActions.spinnerToggle()));
	},
	checkLandingsPopups: (landingId, checked) => (dispatch, getState) => {
		const domains = get(getState(), 'stream.selectedOffer.domains');
		if (!domains) {
			return;
		}
		let landings = domains.filter(domain => domain.type != offerDomainTypes.transit);
		let selectedLandingsIds = getState().stream.selectedLandingsIds;

		if (landingId) {
			selectedLandingsIds = checked ? selectedLandingsIds.concat(landingId) : without(selectedLandingsIds, landingId);
		}
		let result = checkPopupsAvailability(selectedLandingsIds, landings);

		if (!result.popupsAvailability.customer_popups_available || !result.landingsWithFullData.length) {
			dispatch(change('streamForm', 'customer_popups_enabled', ''));
		}
		if (!result.popupsAvailability.phone_button_popup_available || !result.landingsWithFullData.length) {
			dispatch(change('streamForm', 'phone_button_popup_enabled', ''));
		}
		if (!result.popupsAvailability.mouseout_popup_available || !result.landingsWithFullData.length) {
			dispatch(change('streamForm', 'mouseout_popup_enabled', ''));
		}
		if (!result.popupsAvailability.additional_phone_available || !result.landingsWithFullData.length) {
			dispatch(change('streamForm', 'additional_phone_enabled', ''));
		}
		dispatch({
			type: UPDATE_POPUPS_AVAILABILITY,
			payload: {
				selectedLandingsIds,
				popupsAvailability: selectedLandingsIds.length ? result.popupsAvailability : initialState.popupsAvailability
			}
		});
	},

	setPostbackSearch: (value) => (dispatch, getState) => {
		dispatch({
			type: SET_POSTBACK_SEARCH,
			payload: value
		});
	},

	cloneCampaign: () => (dispatch, getState) => {
		const request = http({
			url: endpoints.STREAMS.CLONE + '/' + getState().stream.data.streamItemData.id,
			method: 'post',
			actions: [
				CLONE_ITEM_SUCCESS,
				CLONE_ITEM_ERROR
			]
		});
		dispatch(actions.turnOnSaveButtonLoader());
		request(dispatch).then(() => dispatch(actions.turnOffSaveButtonLoader()));
	},
	...postbackFilters.actions,
	...calendarPostbackList.actions
};

// reducers
const reducers = Object.assign({
	[LOCATION_CHANGE]: (state, action) => {
		window.scrollTo(0, 0);
		if (action.payload.pathname.indexOf('campaigns') !== -1) {
			return initialState;
		}
		return state;
	},
	[SHOW_MORE_POSTBACKS_SUCCESS]: (state, action) => {
		const postbackLog = action.payload.data &&
			map(action.payload.data, postback => {
				postback.date = postback.date.replace('Z', '');
				return postback;
			});

		return {
			...state,
			data: {
				...state.data,
				postbacklog: [
					...state.data.postbacklog,
					...postbackLog
				]
			}
		};
	},
	[FETCH_POSTBACKS_SUCCESS]: (state, action) => {
		const postbacklog = action.payload.data &&
			map(action.payload.data, postback => {
				postback.date = postback.date.replace('Z', '');
				return postback;
			});

		return {
			...state,
			data: {
				...state.data,
				postbacklog: postbacklog && postbacklog.length ? postbacklog : [{}]
			}
		};
	},
	[MORE_POSTBACKS_HIDE]: (state, action) => {
		return {
			...state,
			data: {
				...state.data,
				isShowMoreVisible: false
			}
		};
	},
	[MORE_POSTBACKS_SHOW]: (state, action) => {
		return {
			...state,
			data: {
				...state.data,
				isShowMoreVisible: true
			}
		};
	},
	[TOGGLE_RULES_POPUP]: state => {
		return {
			...state,
			isRulesPopupVisible: !state.isRulesPopupVisible
		};
	},
	[TOGGLE_PROGRESS_BAR]: state => {
		return {
			...state,
			showProgressBar: !state.showProgressBar
		};
	},
	[FETCH_DATA_SUCCESS]: (state, action) => {
		const [
			advSystems,
			landingSnippets,
			campaignDomains,
			spaces,
			userOffers,
			streamItemData = null,
			globalPostbackSets = null,
			postbacklog = null
		] = action.payload;

		if (streamItemData && landingSnippets) {
			const itemLSnippets = streamItemData.data.landings_snippets_codes.landing;
			const itemTSnippets = streamItemData.data.landings_snippets_codes.transit;
			const itemThankyoupageSnippets = streamItemData.data.landings_snippets_codes.thankyoupage;

			streamItemData.data.landings_snippets_codes = {
				landing: filter(itemLSnippets, s => {
					return !!find(landingSnippets.data, it => s.id == it.external_id);
				}),
				transit: filter(itemTSnippets, s => {
					return !!find(landingSnippets.data, it => s.id == it.external_id);
				}),
				thankyoupage: filter(itemThankyoupageSnippets, s => {
					return !!find(landingSnippets.data, it => s.id == it.external_id);
				})
			};
		}

		let selectedLandings = (get(streamItemData, 'data.domains') || [])
			.filter(domain => domain.type !== offerDomainTypes.transit);
		let selectedLandingsIds = selectedLandings.map(landing => pick(landing, 'id').id);

		const postbackLog = postbacklog && postbacklog.data &&
			map(postbacklog.data, l => {
				l.date = l.date.replace('Z', '');
				return l;
			});

		let newState = {
			...state,
			selectedLandingsIds,
			data: {
				landingSnippets: landingSnippets && landingSnippets.data,
				campaignDomains: campaignDomains && campaignDomains.data.map(d => ({
					label: d.text,
					value: d.id
				})),
				spaces: spaces && concat([{title: 'MyTarget', id: -1}], spaces.data),
				userOffers: userOffers.data,
				streamItemData: streamItemData && streamItemData.data,
				globalPostbackSets: globalPostbackSets && globalPostbackSets.data,
				postbacklog: postbackLog,
				isShowMoreVisible: postbackLog && postbackLog.length === initialLimit,
				fields: {
					...state.fields,
					adv_system: advSystems.other
				}
			}
		};
		return newState;
	},
	[FETCH_OFFER_FOR_STREAM_SUCCESS]: (state, action) => {
		const offer = action.payload.data;
		let landings = (offer.domains || []).filter(domain => domain.type != offerDomainTypes.transit);
		let selectedLandingsIds = state.selectedLandingsIds;
		let result = checkPopupsAvailability(selectedLandingsIds, landings);
		const { traffic_source } = action.payload.mixinData;
		const payouts = offer.payouts.filter(i => !traffic_source || traffic_source === i.traffic_source);
		return {
			...state,
			selectedOffer: {
				...offer,
				payouts
			},
			selectedCurrency: null,
			popupsAvailability: result.landingsWithFullData.length ?
				result.popupsAvailability :
				initialState.popupsAvailability
		};
	},
	[FETCH_STATS_FOR_OFFER_SUCCESS]: (state, action) => {
		const geoStats = action.payload.data;
		const currency = action.meta;
		const locations = state.selectedOffer && state.selectedOffer.locations &&
			filter(state.selectedOffer.locations, l => {
				return !!find(state.selectedOffer.payouts,
					p => l.country_code == p.country_code && p.currency == currency.value && p.amount > 0);
			});
		const statsTmp = state.selectedOffer && locations
			&& geoStats && map(
			filter(geoStats, s => !!find(locations, l => s.country_code == l.country_code)), it => {
				const findedLocation = find(locations,
					l => it.country_code == l.country_code);
				const findedPayout = find(state.selectedOffer.payouts,
					p => it.country_code == p.country_code && p.currency == currency.value);
				return {
					...it,
					country_name: findedLocation.name,
					is_own_callcenter: findedLocation.is_own_callcenter,
					is_contest_enabled: findedLocation.is_contest_enabled,
					contest_points: findedLocation.contest_points,
					amount: findedPayout.amount,
					currency: currency.value
				};
			}
		);

		const stats = state.selectedOffer && locations && state.selectedOffer.payouts
			&& statsTmp && map(locations, l => {
			const findedPayout = find(state.selectedOffer.payouts,
				p => l.country_code == p.country_code && p.currency == currency.value && p.amount);
			return find(statsTmp, s => s.country_code == l.country_code)
					|| {
						country_code: l.country_code,
						cr: 0,
						approve: 0,
						country_name: l.name,
						is_own_callcenter: l.is_own_callcenter,
						is_contest_enabled: l.is_contest_enabled,
						contest_points: l.contest_points,
						amount: findedPayout && findedPayout.amount || 0,
						currency: currency.value
					};
		});

		return {
			...state,
			geoStats: {
				rows: stats,
				shouldShowAll: false,
				totalRows: stats && stats.length || 0
			},
			selectedCurrency: currency
		};
	},
	[FETCH_DOMAINS_SUCCESS]: (state, action) => {
		return {
			...state,
			data: {
				...state.data,
				campaignDomains: action.payload && action.payload.data.map(d => ({
					label: d.text,
					value: d.id
				}))
			}
		};
	},
	[FETCH_GEO_LANG_SUCCESS]: (state, action) => {
		return {
			...state,
			geo_rules: action.payload.data.rules
		};
	},
	[FETCH_DATA_ERROR]: (state, action) => {
		return { ...state, error: true };
	},

	// save form
	[SAVE_DATA_ERROR]: (state, action) => {
		if (action.payload.response.data) {
			if (action.payload.response.data[0] && action.payload.response.data[0].dataPath == '.domains') {
				return { ...state, validate: action.payload.response.data[0]};
			}
		}
		return { ...state, validate: {} };
	},

	// sort
	[SORT_BY_COLUMN]: (state, action) => {
		const { columnSorting, landingTransitColumns } = state;
		const { type, columnKey, section } = action.payload;
		const sorting = columnSorting[type];

		const columnDirection = sorting && sorting.key === columnKey
			? sorting.direction === 'desc' ? 'asc' : 'desc'
			: landingTransitColumns[section][columnKey];

		return {
			...state,
			columnSorting: {
				...state.columnSorting,
				[type]: {
					...landingTransitColumns[section][columnKey],
					key: columnKey,
					direction: columnDirection
				}
			}
		};
	},
	[CHANGE_SECTION]: (state, action) => {
		return {
			...state,
			sections: {
				...state.sections,
				active: action.payload
			}
		};
	},
	[SAVE_LOADER_ON]: (state, action) => {
		return {
			...state,
			isSaveButtonLoader: true
		};
	},
	[SAVE_LOADER_OFF]: (state, action) => {
		return {
			...state,
			isSaveButtonLoader: false
		};
	},
	[CHANGE_DISPLAY_TYPE]: (state, action) => {
		const viewType = action.payload === 'landings' ? 'landingsDisplayType': 'transitionsDisplayType';
		return {
			...state,
			[viewType]: state[viewType] === displayType.list ?
				displayType.tile : displayType.list
		};
	},

	[CHANGE_ADV_SYSTEM]: (state, action) => {
		return {
			...state,
			fields: {
				...state.fields,
				adv_system: action.payload.adv_system,
				title: action.payload.title,
				user_offer: action.payload.user_offer,
				currency: action.payload.currency,
				landing_pages: action.payload.landing_pages
			}
		};
	},
	[CHANGE_CURRENCY]: (state, action) => {
		return { ...state, selectedCurrency: action.payload };
	},
	[TOGGLE_GEO_STATS]: (state, action) => {
		return {
			...state,
			geoStats: {
				...state.geoStats,
				shouldShowAll: !state.geoStats.shouldShowAll
			}
		};
	},
	[REFETCH_ALL_DATA]: () => initialState,
	[BOOST_SUCCESS]: (state, action) => {
		return {
			...state,
			selectedOffer: {
				...state.selectedOffer,
				payouts: state.selectedOffer.payouts.map(payout => {
					if (payout && payout.location_id == action.meta.clickedLocation) {
						const currentLocation = state.selectedOffer.locations.find(elem => elem.id === action.meta.clickedLocation);
						payout.amount = Math.round(payout.amount * (1 + Number(currentLocation.boost_value)));
						payout.boost_till = moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
					}

					return payout;
				})
			}
		};
	},
	[BOOST_ERROR]: state => {
		return { ...state, error: true, progressBar: false };
	},
	[REFETCH_ALL_DATA]: () => initialState,
	[UPDATE_POPUPS_AVAILABILITY]: (state, action) => {
		return {
			...state,
			selectedLandingsIds: action.payload.selectedLandingsIds,
			popupsAvailability: action.payload.popupsAvailability
		};
	},

	[SET_POSTBACK_SEARCH]: (state, action) => {
		return {
			...state,
			postbackSearch: action.payload
		};
	},

	// clone item
	[CLONE_ITEM_SUCCESS]: (state, action) => {
		const clonedCampaignId =  get(action, 'payload.data.id', null);
		window.location.assign('/campaigns');
		return {
			...state,
			highlightedRowId: clonedCampaignId,
			data: null
		};
	},
	[CLONE_ITEM_ERROR]: (state, action) => {
		return {...state, error: true};
	}
}, pagination.reducers, postbackFilters.reducers, calendarPostbackList.reducers);

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.stream.data,
	getLists: state => state.app.lists,
	getProgressBar: state => state.stream.showProgressBar,
	getFormSelectedCountry: state => get(getFormValues('streamForm')(state), 'country_code.value'),
	getGeoRules: state => state.stream.geo_rules,
	getSaveLoader: state => state.stream.isSaveButtonLoader,
	getFormSelectedLang: state => get(getFormValues('streamForm')(state), 'language.value'),
	getShowMoreVisibility: state => state.stream.data && state.stream.data.isShowMoreVisible,
	getUserData: state => state.app.userData.general,
	getSelectedLandings: state => state.stream.selectedLandingsIds,
	getFilters: state => postbackFilters.selectors.selectFilters(
		state => state.stream.filters, state => state
	)(state),
	getAppliedFilters: state => postbackFilters.selectors.appliedFilters(state),
	getPostbackListCalendar: state => calendarPostbackList.selectors.getCalendar(
		state => state.stream.calendarPostbackList,
		state => state
	)(state),
	getSections: state => ({
		list: state.stream.sections.list,
		active: state.stream.sections.active
	}),
	getCampaignDomains: state => state.stream.data && state.stream.data.campaignDomains,
	trafficSources: state => ({
		trafficSources: state.app.lists['traffic-sources']
			.map(i => ({label: selectors.getIntl(state)(i.text), value: i.text}))
			.filter(i => !['general', 'social'].includes(i.label))
	}),
	getSelectOptions: state => ({
		spaces: getSpacesOptions(state),
		currencies: state.stream.data && state.stream.selectedOffer && (() => {
			const offer = getOffer(state);
			if (offer && offer.payouts) {

				const country_code = selectors.getFormSelectedCountry(state);
				const offerPayouts = offer.payouts
					.filter(op => op.country_code === country_code && op.amount > 0.01)
					.filter(op => state.app.userData.balances.some(balance => balance.currency === op.currency))
					.filter(op => state.app.lists['payout-currencies'].some(currency => currency.id === op.currency))
					.map(({ currency }) => ({ id: currency, text: currency }));
				return formatEnumFormOptions(uniqBy(offerPayouts, 'id'));
			}
			return [];
		})(state),
		campaignDomains: state.stream.data && state.stream.data.campaignDomains,
		languages: state.stream.data && state.stream.selectedOffer && (() => {
			const offer = getOffer(state);

			const availableLangs = getLangsByTargetRelation(offer);

			return availableLangs.map(lang => {
				const langFromLists = find(state.app.lists['landing-languages'], entity => entity.id == lang);
				return {
					label: langFromLists.text,
					value: lang
				};
			});

		})(state),
		geos: state.stream.data && state.stream.selectedOffer && (() => {
			const locations = state.stream.geoStats && state.stream.geoStats.rows;

			if (!locations) {
				return [];
			}

			return locations.filter(l => !checkIsExcludedCountryCode(l.country_code)).map(l => {
				return {
					label: l.country_name,
					value: l.country_code
				};
			});
		})(state)
	}),
	getDomainTooltipStatus: state => {
		const streamFormSelector = formValueSelector('streamForm');
		const landingInternalSubdomain = streamFormSelector(state, 'internal_landing_subdomain');
		const transitInternalSubdomain = streamFormSelector(state, 'internal_transit_subdomain');
		const redirectInternalSubdomain = streamFormSelector(state, 'internal_redirect_subdomain');

		return {
			shouldShowForLanding: isEmpty(landingInternalSubdomain),
			shouldShowForTransit: isEmpty(transitInternalSubdomain),
			shouldShowForRedirect: isEmpty(redirectInternalSubdomain)
		};
	},
	getSplitSessionTooltipStatus: state => {
		const formData = getFormValues('streamForm')(state);
		let showShowForSplitSession = false;

		if (isObject(formData)) {
			const landingPages = getPagesByType(formData, 'landing_pages_id');
			const transitPages = !formData['disable-transit-page'] && getPagesByType(formData, 'transit_pages_id') || [];
			const currentData = state.stream.data && state.stream.data.streamItemData;

			const isSplitTestEnabled = landingPages.length > 1 || transitPages.length > 1;
			const isSplitTestSettingsChange = getSplitTestChangeStatus(({
				landing_pages: landingPages,
				transit_pages: transitPages
			}), currentData);

			showShowForSplitSession = isSplitTestEnabled && isSplitTestSettingsChange;
		}
		return showShowForSplitSession;
	},
	getTableData: state => {
		if (!state.stream.data) {
			return null;
		}
		const offer = getOffer(state) || null;

		const lang = state.stream.data.streamItemData
			&& ({
				label: find(state.app.lists['landing-languages'], ll =>
					ll.id == state.stream.data.streamItemData.language
				).text,
				value: state.stream.data.streamItemData.language
			})
			|| state.form && state.form.streamForm && state.form.streamForm.values && state.form.streamForm.values.language
			|| null;

		if (offer && lang) {
			offer.landing_pages = offer.domains && offer.domains.filter(it =>
				it.type == offerDomainTypes.landing && find(it.languages, l => l == lang.value)
			);
			const lostLandings = state.stream && state.stream.data && offer.landing_pages
				&& state.stream.data.streamItemData
				&& map(filter(state.stream.data.streamItemData.domains, p => {
					return p.type == offerDomainTypes.landing && !find(offer.landing_pages, lr => lr.id == p.id);
				}), r => {
					r.removed = true;
					return r;
				}) || [];
			if (offer.landing_pages) {
				offer.landing_pages = concat(offer.landing_pages, lostLandings);
			}

			offer.transit_pages = offer.domains && offer.domains.filter(it =>
				it.type == offerDomainTypes.transit && find(it.languages, l => l == lang.value)
			);
			const lostTransits = state.stream && state.stream.data && offer.transit_pages
				&& state.stream.data.streamItemData
				&& map(filter(state.stream.data.streamItemData.domains, p => {
					return p.type == offerDomainTypes.transit && !find(offer.transit_pages, lr => lr.id == p.id);
				}), r => {
					r.removed = true;
					return r;
				}) || [];
			if (offer.transit_pages) {
				offer.transit_pages = concat(offer.transit_pages, lostTransits);
			}
		}

		let landingsRows = offer && lang && pagination.selectors.getPageData(
			state => sortByColumn(state.stream.columnSorting.landing, offer.landing_pages),
			state => state.stream.pagination.LandingsTable.perPage,
			state => state.stream.pagination.LandingsTable.currentPage
		)(state);

		let transitionsRows = offer && lang && pagination.selectors.getPageData(
			state => sortByColumn(state.stream.columnSorting.transit, offer.transit_pages),
			state => state.stream.pagination.TransitionsTable.perPage,
			state => state.stream.pagination.TransitionsTable.currentPage
		)(state);

		return ({
			landings: {
				paginated: landingsRows,
				displayType: state.stream.landingsDisplayType
			},
			transitions: {
				paginated: transitionsRows,
				displayType: state.stream.transitionsDisplayType
			},
			selectedOffer: offer
		}) || {landings: {}, transitions: {}, selectedOffer: null};
	},
	getFormData: state => state.stream.data && ({
		fields: getInitialFormFields(state),
		errors: state.stream.validate,
		disabledStatus: getDisabledFieldStatus(state),
		checkboxDisabledStatus: getCheckboxDisabledStatus(state),
		values: get(state, 'form.streamForm.values', {})
	}),
	isEditMode: state => state.stream.data && !!state.stream.data.streamItemData,
	canEdit: state => state.stream.data &&
		state.stream.data.streamItemData &&
		!state.stream.data.streamItemData.removed_at,
	getShouldShowStatus: state => {
		const streamFormSelector = formValueSelector('streamForm');
		return {
			disableTransitPage: streamFormSelector(state, 'disable-transit-page')
		};
	},
	getLandingSnippets: state => state.stream.data && state.stream.data.landingSnippets,
	getError: state => state.stream.error,
	isOtherAdv : state => getAdvSystemFormValue(state) === advSystems.other,
	isNewOrEditingActiveCampaign : state => {
		return (state.stream.data && !!state.stream.data.streamItemData) ?
			!!state.stream.data.streamItemData.is_active : true;
	},
	isMyTargetAdv: state => getAdvSystemFormValue(state) === advSystems.target_mail,
	getPostBackLog: state => state.stream.data && state.stream.data.postbacklog,
	getOfferGeoStats: state => {
		const offerData = state.stream.selectedOffer;
		const stats = state.stream.geoStats;

		if (offerData && stats) {
			const goals = calculateGeoGoals(offerData).goals;

			const statWithBoostData = stats.rows.map(entity => {
				const countryCode = entity.country_code;
				const getGoalsByCountryCode = find(goals, {'locationCountryCode': countryCode}) || [];
				const payout = find(getGoalsByCountryCode.payouts, { payoutCurrency: entity.currency }) || {payout: 0};

				const dataForMixed = pick(getGoalsByCountryCode, [
					'boost_info',
					'boost_value',
					'boost_till',
					'isBoosterAvailable',
					'locationId'
				]);

				const individualTermsFilter = countryName => entity => (
					entity.is_individual_term &&
					entity.country_code === countryName
				);

				const isIndividualTerm = (offerData.payouts.filter(
					individualTermsFilter(entity.country_code))
				).length;

				return {
					...entity,
					...dataForMixed,
					amount: payout.payout,
					offerAvailable: offerData.available && offerData.status !== offerStatuses.stopped,
					is_individual_term: isIndividualTerm,
					isDifferentFromBasePayout: payout.isDifferentFromBasePayout,
					differenceBetweenBaseAndIndividual: payout.differenceBetweenBaseAndIndividual
				};
			});

			return {
				...stats,
				rows: sortBy(statWithBoostData, i => i.country_name)
			};
		}
		return stats;
	},
	getSelectedCurrency: state => {
		if (!state.stream.data) {
			return;
		}
		const { streamItemData } = state.stream.data;
		const offer = getOffer(state);
		return determineBestCurrency(streamItemData, offer, state);
	},
	getLandingTransitHeaders: state => state.stream.landingTransitColumns,
	getColumnSorting: state => state.stream.columnSorting,
	getCalendar: state => calendarPostbackList.selectors.getCalendar(
		state => state.stream.calendarPostbackList,
		state => state
	)(state),
	getIntl: state => intl(state),
	getUserBoostInfo: state => state.app.userData.general.boost_info,
	getSelectedOfferData: state => state.stream.selectedOffer,
	getPopupsAvailability: state => state.stream.popupsAvailability,
	getPostbackSearch: state => state.stream.postbackSearch,
	getCurrentChain: state => get(state, ['routing', 'locationBeforeTransitions', 'state', 'chain'], {})
};

const getDisabledFieldStatus = state => {
	const streamFormSelector = formValueSelector('streamForm');
	const landingDomainType = streamFormSelector(state, 'landing_domain_type');
	const transitDomainType = streamFormSelector(state, 'transit_domain_type');
	const redirectDomainType = streamFormSelector(state, 'redirect_domain_type');

	return {
		external_landing_domain: landingDomainType === domainTypes.internal,
		internal_landing_domain: landingDomainType === domainTypes.external,
		internal_landing_subdomain: landingDomainType === domainTypes.external,

		external_transit_domain: transitDomainType === domainTypes.internal,
		internal_transit_domain: transitDomainType === domainTypes.external,
		internal_transit_subdomain: transitDomainType === domainTypes.external,

		external_redirect_domain: redirectDomainType === domainTypes.internal,
		internal_redirect_domain: redirectDomainType === domainTypes.external,
		internal_redirect_subdomain: redirectDomainType === domainTypes.external
	};
};

const getCheckboxDisabledStatus = state => {
	const streamFormSelector = formValueSelector('streamForm');
	const isPostbackTypeApprove = streamFormSelector(state, 'postback_only_approved');
	const isPostbackTypeStatus = streamFormSelector(state, 'postback_send_status');
	const isPostbackOnlyPending = streamFormSelector(state, 'postback_only_pending');
	const isPostbackOnlyRejected = streamFormSelector(state, 'postback_only_rejected');
	const isPostbackOnlyTrash = streamFormSelector(state, 'postback_only_trash');

	return {
		'postback_send_status':
			!!isPostbackTypeApprove || !!isPostbackOnlyPending || !!isPostbackOnlyRejected || !!isPostbackOnlyTrash,
		'postback_ignore_trash': !!isPostbackTypeApprove
			|| (!isPostbackTypeApprove && !isPostbackTypeStatus)
			|| !!isPostbackOnlyPending,
		'postback_only_approved': !!isPostbackTypeStatus,
		'postback_only_pending': !!isPostbackTypeStatus,
		'postback_only_rejected': !!isPostbackTypeStatus,
		'postback_only_trash': !!isPostbackTypeStatus,
		'send_payout_for_approved_only': false
	};
};

const getInitialFormFields = (state) => {
	let { streamItemData, campaignDomains } = state.stream.data;
	const offer = getOffer(state);
	const space = streamItemData && find(state.stream.data.spaces, it => it.id == streamItemData.space_id);

	const currency = determineBestCurrency(streamItemData, offer, state);
	const language = determineBestLanguage(streamItemData, offer, state);

	const advSystem = streamItemData
		&& findValueForSelectInList(state.app.lists['adv-systems'], streamItemData.adv_system);

	const postbackType = state.form && state.form.streamForm && state.form.streamForm.values
		&& state.form.streamForm.values.postback_type
		|| streamItemData && streamItemData.postback_type;
	const selectedPostbackTypes = get(streamItemData, 'postback_config.postback_types')
		|| [ postbackType ];

	const lDomainType = streamItemData && streamItemData.landing_domain_type || domainTypes.internal;
	const tDomainType = streamItemData && streamItemData.transit_domain_type || domainTypes.internal;
	const rDomainType = streamItemData && streamItemData.redirect_domain_type || domainTypes.internal;

	const matchedLandDomain = streamItemData && streamItemData.landing_domain
		&& lDomainType === domainTypes.internal
		&& streamItemData.landing_domain.match(/(.+?)\.(.+)/);
	const matchedTransitDomain = streamItemData && streamItemData.transit_domain
		&& tDomainType === domainTypes.internal
		&& streamItemData.transit_domain.match(/(.+?)\.(.+)/);
	const matchedRedirectDomain = streamItemData && streamItemData.redirect_domain
		&& rDomainType === domainTypes.internal
		&& streamItemData.redirect_domain.match(/(.+?)\.(.+)/);

	const lDomainObj = streamItemData && streamItemData.landing_domain
		&& lDomainType === domainTypes.internal
		&& matchedLandDomain
		&& {domain: matchedLandDomain[2], subdomain: matchedLandDomain[1]};
	const tDomainObj = streamItemData && streamItemData.transit_domain
		&& tDomainType === domainTypes.internal
		&& matchedTransitDomain
		&& {domain: matchedTransitDomain[2], subdomain: matchedTransitDomain[1]};
	const rDomainObj = streamItemData && streamItemData.redirect_domain
		&& rDomainType === domainTypes.internal
		&& matchedRedirectDomain
		&& {domain: matchedRedirectDomain[2], subdomain: matchedRedirectDomain[1]};

	const landingDomain = lDomainObj && lDomainObj.domain || null;
	const landingSubDomain = lDomainObj && lDomainObj.subdomain || null;
	const transitDomain = tDomainObj && tDomainObj.domain || null;
	const transitSubDomain = tDomainObj && tDomainObj.subdomain || null;
	const redirectDomain = rDomainObj && rDomainObj.domain || null;
	const redirectSubDomain = rDomainObj && rDomainObj.subdomain || null;

	const lDomainInListRemoved = streamItemData && find(campaignDomains, d => d.value == landingDomain);
	const tDomainInListRemoved = streamItemData && find(campaignDomains, d => d.value == transitDomain);
	const lDomainInList = streamItemData && !lDomainInListRemoved && find(campaignDomains, d => d.label == landingDomain);
	const tDomainInList = streamItemData && !tDomainInListRemoved && find(campaignDomains, d => d.label == transitDomain);

	const initialData = Object.assign(
		{ ...state.stream.fields },
		{
			internal_landing_domain: campaignDomains[0],
			internal_transit_domain: campaignDomains[0],
			internal_redirect_domain: volatiles.getDefaultRedirectDomain(campaignDomains),
			postback_send_status: state.stream.fields.postback_send_status,
			postback_only_approved: state.stream.fields.postback_only_approved,
			postback_ignore_trash: state.stream.fields.postback_ignore_trash,
			currency,
			language,
			landing_domain_type: lDomainType,
			redirect_domain_type: rDomainType
		}, isObject(streamItemData) && {
			...streamItemData,
			postback_send_status: selectedPostbackTypes.includes(postbackTypes.status),
			postback_only_approved: selectedPostbackTypes.includes(postbackTypes.approve),
			postback_only_pending: streamItemData.postback_only_pending
				|| selectedPostbackTypes.includes(postbackTypes.pending),
			postback_only_rejected: selectedPostbackTypes.includes(postbackTypes.rejected),
			postback_only_trash: selectedPostbackTypes.includes(postbackTypes.trash),
			postback_ignore_restricted: get(streamItemData, 'postback_config.postback_ignore_restricted'),
			postback_on_payout_change: get(streamItemData, 'postback_config.postback_on_payout_change'),
			postback_url: streamItemData && streamItemData.postback_url || null,
			trafficback_url: streamItemData && streamItemData.trafficback_url || null,
			currency,
			language,
			adv_system: advSystem,
			space: streamItemData.adv_system !== advSystems.target_mail
				? space && {label: space.title, value: space.id} || null
				: {label: 'MyTarget', value: -1},
			user_offer: offer && {label: offer.title, value: offer.id} || null,
			internal_landing_domain: streamItemData.landing_domain
				&& lDomainType === domainTypes.internal
				? matchedLandDomain && lDomainInList || lDomainInListRemoved
					|| {label: `${landingDomain} (removed)`, value: null}
				: matchedLandDomain && {label: landingDomain, value: null} || campaignDomains[0],
			internal_transit_domain: streamItemData.transit_domain
				&& tDomainType === domainTypes.internal
				? matchedTransitDomain && tDomainInList || tDomainInListRemoved
					|| {label: `${transitDomain} (removed)`, value: null}
				: matchedTransitDomain && {label: transitDomain, value: null} || campaignDomains[0],
			internal_redirect_domain: streamItemData.redirect_domain
				&& rDomainType === domainTypes.internal
				? volatiles.getDefaultRedirectDomain(campaignDomains)
				: matchedRedirectDomain
					&& {label: redirectDomain, value: null}
					|| volatiles.getDefaultRedirectDomain(campaignDomains),
			internal_landing_subdomain: streamItemData.landing_domain
				&& lDomainType === domainTypes.internal
				? landingSubDomain : streamItemData.internal_landing_subdomain,
			internal_transit_subdomain: streamItemData.transit_domain
				&& tDomainType === domainTypes.internal
				? transitSubDomain : streamItemData.internal_transit_subdomain,
			internal_redirect_subdomain: streamItemData.redirect_domain
				&& rDomainType === domainTypes.internal
				? redirectSubDomain : streamItemData.internal_redirect_subdomain,
			external_landing_domain: streamItemData.landing_domain
				&& lDomainType === domainTypes.external
				? streamItemData.landing_domain : null,
			external_transit_domain: streamItemData.transit_domain
				&& tDomainType === domainTypes.external
				? streamItemData.transit_domain : null,
			external_redirect_domain: streamItemData.redirect_domain
				&& rDomainType === domainTypes.external
				? streamItemData.redirect_domain : null,
			...getLandingSnippetsFields(streamItemData.landings_snippets_codes)
		},
		isObject(streamItemData) && advSystem && advSystem.value == advSystems.other && offer && {
			...getPagesFromItemField(streamItemData.domains, offer.domains, offerDomainTypes.landing),
			...getPagesFromItemField(streamItemData.domains, offer.domains, offerDomainTypes.transit)
		},
		isObject(streamItemData) && advSystem && advSystem.value !== advSystems.other && offer && {
			transit_pages: null,
			...getPagesFromItemField(streamItemData.domains, offer.domains, offerDomainTypes.landing)
		},
		offer && {
			user_offer: offer && {label: offer.title, value: offer.id} || null
		},
		{
			transit_domain_type: tDomainType
		}
	);
	return initialData;
};

const findValueForSelectInList = (list, value) => {
	return find(formatEnumFormOptions(list), it => it.value == value);
};

const determineBestCurrency = (stream, offer, state) => {
	if (stream) {
		return findValueForSelectInList(state.app.lists['available-currencies'], stream.currency);
	}
	if (offer) {
		const currenciesIntersection = intersectionBy(state.app.userData.balances, offer.payouts, 'currency');
		if (!isEmpty(currenciesIntersection)) {
			const availPayoutCurrencies = formatEnumFormOptions(
				map(currenciesIntersection, it => {
					return find(state.app.lists['available-currencies'], c => c.id == it.currency);
				})
					.filter(ci => !!ci)
			);
			if (!stream && !isRocket) {
				return { label: 'usd', value: 'usd' };
			}

			const byActiveBalance = find(offer.payouts, p => p.currency == state.app.userData.activeBalance)
				&& find(availPayoutCurrencies, it => it.value == state.app.userData.activeBalance);
			const byConnectedBalances = !isEmpty(currenciesIntersection) && availPayoutCurrencies
				&& find(availPayoutCurrencies, it => it.value == currenciesIntersection[0].currency);
			if (byActiveBalance || byConnectedBalances) {
				if (availPayoutCurrencies.length == 1) {
					return availPayoutCurrencies[0];
				}
				const formData = getFormValues('streamForm')(state);
				if (availPayoutCurrencies.find(i => i.value === 'rub') && !(formData.currency && formData.currency.value)) {
					return availPayoutCurrencies.find(i => i.value === 'rub');
				}
				if (formData.currency && formData.currency.value) {
					return formData.currency;
				}
				return byActiveBalance || byConnectedBalances;
			}
		} else {
			return {label: '', value: -1};
		}
	}
	return state.stream.selectedCurrency;
};

const determineBestLanguage = (stream, offer, state) => {
	const availLangs = state.app.lists['landing-languages'];
	if (stream) {
		return findValueForSelectInList(availLangs, stream.language);
	}
	if (offer) {
		let langsFromLT = [];
		forEach(offer.domains, d => {
			langsFromLT = concat(langsFromLT, d.languages);
		});
		langsFromLT = map(uniq(langsFromLT), l => {
			const langFromLists = find(availLangs, al => al.id == l);
			return {
				label: langFromLists.text,
				value: l
			};
		});
		const langs = uniqBy(langsFromLT, 'value');
		if (langs && !isEmpty(langs)) {
			return langs.length == 1 ? langs[0] : null;
		}
	}
	return null;
};

// request create helpers
const createRequest = (data, state) => {
	const offer = getOffer(state);
	const isExternalOffer = offer.external_integration;
	const isRedirect = offer.use_redirect;
	const isOtherAdv = selectors.isOtherAdv(state);
	const isMyTargetAdv = selectors.isMyTargetAdv(state);
	const currentData = state.stream.data.streamItemData;
	const isNewCampaign = !get(state, 'stream.data.streamItemData.id');
	const currency = isNewCampaign ? 'usd' : state.stream.selectedCurrency && state.stream.selectedCurrency.value;
	const chain = get(state, ['routing', 'locationBeforeTransitions', 'state', 'chain'], {});
	const landingPages = isOtherAdv
		? getPagesByType(data, 'landing_pages_id')
		: [{id: parseInt(data.landing_pages)}];
	const landing_domain_type = data.landing_domain_type;
	const redirect_domain_type = data.redirect_domain_type;
	const transit_domain_type = data.transit_domain_type;
	const transitPageDisabled = data['disable-transit-page'];

	let landing_domain = landing_domain_type === domainTypes.internal
		? get(data, 'internal_landing_domain.label', null)
		: data.external_landing_domain || null;
	let transit_domain = transit_domain_type === domainTypes.internal
		? get(data, 'internal_transit_domain.label', null)
		: data.external_transit_domain || null;
	let redirect_domain = redirect_domain_type === domainTypes.internal
		? get(data, 'internal_redirect_domain.label', null)
		: data.external_redirect_domain || null;

	const transitPages = !transitPageDisabled && (!isEmpty(landingPages) || isExternalOffer) && transit_domain
			&& getPagesByType(data, 'transit_pages_id') || [];

	const postback_type = data.postback_only_approved ? postbackTypes.approve :
		data.postback_send_status ? postbackTypes.status : null;
	const postback_ignore_trash = postback_type == postbackTypes.status
		? !!data.postback_ignore_trash : false;

	const randSubdomain = randExp.randexp(/^[a-z]{7,7}$/);

	if (landing_domain_type === domainTypes.internal) {
		let domainRemoved = landing_domain && landing_domain.match(/^(.+)\s\(removed\)$/);
		if (domainRemoved && domainRemoved.length === 2) {
			landing_domain = domainRemoved[1];
		}
		if (!isExternalOffer) {
			let landingSubdomain = data.internal_landing_subdomain || 'l' + randSubdomain;
			landing_domain = landingSubdomain + '.' + landing_domain;
		}
	}
	if (transit_domain && transit_domain_type === domainTypes.internal) {
		let domainRemoved = transit_domain && transit_domain.match(/^(.+)\s\(removed\)$/);
		if (domainRemoved && domainRemoved.length === 2) {
			transit_domain = domainRemoved[1];
		}
		let transitSubdomain = data.internal_transit_subdomain || 't' + randSubdomain;
		transit_domain = transitSubdomain + '.' + transit_domain;
	}
	if (redirect_domain && redirect_domain_type === domainTypes.internal) {
		let domainRemoved = redirect_domain && redirect_domain.match(/^(.+)\s\(removed\)$/);
		if (domainRemoved && domainRemoved.length === 2) {
			redirect_domain = domainRemoved[1];
		}
		let redirectSubdomain = data.internal_redirect_subdomain || 'r' + randSubdomain;
		redirect_domain = redirectSubdomain + '.' + redirect_domain;
	}

	if (landing_domain == transit_domain) {
		const validationsErrors = {};
		const error = intl(state)('Домены лэндинга и транзитки должны отличаться');
		if (landing_domain_type === domainTypes.internal) {
			validationsErrors.internal_landing_subdomain = error;
			validationsErrors.internal_transit_subdomain = error;
		} else {
			validationsErrors.external_landing_domain = error;
			validationsErrors.external_transit_domain = error;
		}

		throw new SubmissionError(validationsErrors);
	}

	const landingSnippetCodes = {
		landing: getSnippetsByType(data, 'landing_snippet_'),
		transit: getSnippetsByType(data, 'transit_snippet_'),
		thankyoupage: getSnippetsByType(data, 'thankyoupage_snippet_')
	};

	const isFromChain = checkIsFromChain(chain, landingPages, transitPages);

	let request = {
		...data,
		currency: isRocket ? 'usd' : currency,
		customer_popups_enabled: !!data.customer_popups_enabled,
		phone_button_popup_enabled: !!data.phone_button_popup_enabled,
		mouseout_popup_enabled: !!data.mouseout_popup_enabled,
		additional_phone_enabled: !!data.additional_phone_enabled,
		postback_type: null,
		traffic_source: (data.traffic_source && data.traffic_source.value) || data.traffic_source,
		postback_ignore_trash,
		postback_url: !isEmpty(data.postback_url) ? data.postback_url : null,
		postback_config: {
			postback_ignore_restricted: !!data.postback_ignore_restricted,
			postback_on_payout_change: !!data.postback_on_payout_change,
			postback_types: getSelectedPostbackTypes(data)
		},
		trafficback_url: !isEmpty(data.trafficback_url) ? data.trafficback_url : null,
		language: data.language && data.language.value,
		adv_system: isOtherAdv ?  advSystems.other : advSystems.target_mail,
		space_id: data.space && data.space.value !== -1 ? data.space.value : null,
		offer_id: offer && offer.id || null,
		landing_domain: !isExternalOffer ? landing_domain : undefined,
		transit_domain: !isEmpty(transitPages) && transit_domain ? transit_domain : null,
		redirect_domain: isRedirect ? redirect_domain : undefined,
		landing_domain_type,
		transit_domain_type: !isEmpty(transitPages) && transit_domain ? transit_domain_type : null,
		domains: isExternalOffer && transitPageDisabled ? null: concat(landingPages, transitPages),
		is_split_test_enabled: landingPages.length > 1 || transitPages.length > 1,
		is_split_test_settings_change: getSplitTestChangeStatus({
			landing_pages: landingPages,
			transit_pages: transitPages
		}, currentData),
		landings_snippets_codes: landingSnippetCodes,
		chain_id: isFromChain ? chain.id : 0,
		country_code: (data.country_code && data.country_code.value) || data.country_code
	};

	if (!isOtherAdv) {
		const buildRequest = {};

		const excludeMyTarget = state.stream.excludeFieldsForMyTargetSystem;
		const excludeVK = state.stream.excludeFieldsForNotAdvSystem;

		const excludeFields = isMyTargetAdv ? excludeMyTarget : excludeVK;

		Object.keys(request).forEach(key => {
			if (excludeFields.indexOf(key) === -1) {
				buildRequest[key] = request[key];
			}
		});

		request = {
			...buildRequest,
			is_split_test_enabled: false,
			transit_pages: [],
			landing_domain: isMyTargetAdv ? buildRequest.landing_domain : null,
			transit_domain: null
		};
	}
	return request;
};

const getSplitTestChangeStatus = (data, currentData) => {

	const currentLandingPages = currentData && currentData.domains
		&& currentData.domains.filter(p => p.type == offerDomainTypes.landing).map(p => +p.id);
	const newLandingPages = data.landing_pages.map(page => +page.id);

	const currentTransitPages = currentData && currentData.domains
		&& currentData.domains.filter(p => p.type == offerDomainTypes.transit).map(p => +p.id);
	const newTransitPages = data.transit_pages.map(page => +page.id);

	const isDifferenceLandingPages = (
		(difference(currentLandingPages, newLandingPages)).length > 0 ||
		(difference(newLandingPages, currentLandingPages)).length > 0
	);
	const isDifferenceTransitPages = (
		(difference(currentTransitPages, newTransitPages)).length > 0 ||
		(difference(newTransitPages, currentTransitPages)).length > 0
	);

	return isDifferenceLandingPages || isDifferenceTransitPages;
};

const sortByColumn = (sortByColumn, rows) => {
	if (!rows) return null;
	if (!sortByColumn) return rows;

	return orderBy(
		rows,
		row => {
			const value = row[sortByColumn.position];
			switch (sortByColumn.position) {
				case 'cr':
				case 'epc':
					return parseFloat(value);
				default:
					return value;
			}
		},
		sortByColumn.direction
	);
};

const getAdvSystemFormValue = (state) => {
	const formData = getFormValues('streamForm')(state);
	return formData && formData.space && formData.space.value == -1 ? advSystems.target_mail : advSystems.other;
};

const getOffer = (state) => {
	const selectedOfferId = state.stream.data.streamItemData && state.stream.data.streamItemData.offer_id
		|| state.stream.selectedOffer && state.stream.selectedOffer.id || null;

	if (selectedOfferId) {
		return state.stream.selectedOffer && state.stream.selectedOffer.title && state.stream.selectedOffer;
	}
	return null;
};

const getSpacesOptions = (state) => {
	// @todo Need rework this module. Confused name collision adv_system
	if (!state.stream.data) return null;

	const formInitialValues = getInitialFormFields(state);
	const isRocketDashboard = process.env.CPA_ENV === 'rocket';
	const options = map(state.stream.data.spaces, it => ({
		label: it.title,
		value: parseInt(it.id)
	}));

	if (isRocketDashboard) {
		const savedSpacesIsMyTarget = formInitialValues.adv_system && formInitialValues.adv_system.value === 'target_mail';
		return savedSpacesIsMyTarget ? options : options.filter(option => option.value !== -1);
	}

	return options;
};

const checkPopupsAvailability = (selectedLandingsIds, landings) => {
	let landingsWithFullData = [];
	selectedLandingsIds.forEach(id => {
		landingsWithFullData.push(find(landings, { id }));
	});

	const customer_popups_available = every(landingsWithFullData, {customer_popups_available: true});
	const phone_button_popup_available = every(landingsWithFullData, {phone_button_popup_available: true});
	const mouseout_popup_available = every(landingsWithFullData, {mouseout_popup_available: true});
	const additional_phone_available = every(landingsWithFullData, {additional_phone_available: true});
	return {
		landingsWithFullData,
		popupsAvailability: {
			customer_popups_available,
			phone_button_popup_available,
			mouseout_popup_available,
			additional_phone_available
		}
	};
};

function getPostbackFilters(state) {
	const filters = {};

	const appliedFilters = selectors.getAppliedFilters(state);
	appliedFilters.forEach(fltr => filters[fltr.suggestId]
		? (filters[fltr.suggestId].push(fltr.itemId))
		: (filters[fltr.suggestId] = [fltr.itemId])
	);
	const sidFilters = get(selectors.getFilters(state), 'list.0.suggest', {});
	['sid1', 'sid2', 'sid3', 'sid4', 'sid5'].forEach(sd => {
		const sidValue = get(sidFilters, `${sd}.suggestQuery`);

		if (sidValue) {
			filters[sd] = sidValue;
		}
	});
	let {start, end} = selectors.getCalendar(state).value;
	start = moment(start).hours(0).minutes(0).seconds(0).milliseconds(0);
	end = moment(end).hours(23).minutes(59).seconds(59).milliseconds(999);

	filters['date_range'] = {
		start: start.format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
		end: end.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
	};

	return filters;
}

function createCsvFromArray(rows) {
	return csv(rows, (err, res) => {
		const exportFilename = `Export--Postbacks--${moment().format(
			'YYYY-MM-DD--HH-mm-ss'
		)}.csv`;
		const csvData = new Blob([res], { type: 'text/csv;charset=utf-8;' });
		//IE11 & Edge
		if (navigator.msSaveBlob) {
			navigator.msSaveBlob(csvData, exportFilename);
		} else {
			//In FF link must be added to DOM to be clicked
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(csvData);
			link.setAttribute('download', exportFilename);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	});
}

function getSelectedPostbackTypes(data) {
	const postbackTypes = Object.keys(postbackTypeToCheckboxMapping)
		.filter( pt => !!data[pt])
		.map( pt => postbackTypeToCheckboxMapping[pt]);

	return postbackTypes.length ? postbackTypes : null;
}


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/single/index.js